<script setup>
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@stores/AuthStore';
import { onMounted } from 'vue';
import { jwtDecode } from 'jwt-decode';

const { locale } = useI18n({ useScope: 'global' });
const authStore = useAuthStore();

// Функция для проверки и восстановления авторизации
const restoreAuth = () => {
    try {
        const userData = localStorage.getItem('user');
        const userToken = localStorage.getItem('userToken');

        if (!userData || !userToken) {
            authStore.logout();
            return;
        }

        let parsedUser;
        try {
            parsedUser = JSON.parse(userData);
        } catch (parseError) {
            console.error('Invalid user data in localStorage:', parseError);
            authStore.logout();
            return;
        }

        // Verify token is valid JWT and decode fresh data
        let decoded;
        try {
            decoded = jwtDecode(userToken);
        } catch (jwtError) {
            console.error('Invalid JWT token:', jwtError);
            authStore.logout();
            return;
        }

        // Check token expiration using fresh decoded data
        const isExpired = decoded.exp * 1000 < Date.now();
        if (isExpired) {
            console.log('Token expired, logging out');
            authStore.logout();
            return;
        }

        // Проверяем обязательные поля из сохраненных данных пользователя
        if (!parsedUser || !parsedUser.image || !parsedUser.full_name) {
            console.error('Missing required user data');
            authStore.logout();
            return;
        }

        // Восстанавливаем авторизацию с актуальным токеном
        authStore.setAuthData(userToken, parsedUser.image, parsedUser.full_name);

        // Устанавливаем локаль
        if (parsedUser.locale) {
            locale.value = parsedUser.locale;
        }
    } catch (error) {
        console.error('Ошибка при восстановлении авторизации:', error);
        authStore.logout();
    }
};

// Выполняем восстановление авторизации после монтирования компонента
onMounted(() => {
    restoreAuth();
});
</script>

<template>
    <router-view />
</template>

<style scoped></style>
